<template>
  <div class="g-share-box">
    <div class="left_box" :style="{ width: leftWidth + 'px' }"></div>
    <template v-if="$store.state.app.language == 'zh-cn'">
      <i class="u-icon iconfont icon-weixin" :data-active="value.find(item => item === 'weixin')"
       @click="select('weixin')"></i>
      <i class="u-icon iconfont icon-weibo-copy1" :data-active="value.find(item => item === 'weibo')"
        @click="select('weibo')"></i>
      <i class="u-icon iconfont icon-qq" :data-active="value.find(item => item === 'qq')" @click="select('qq')"></i>
    </template>
    <template v-else>
      <img class="svg_icon svg_icon_twitter" :data-active="value.find(item => item === 'twitter')" @click="select('twitter')" src="https://sitecdn.71360.com/static/txys-001/wm/image/share/twitter_new.png?my_version_number=123" alt="twitter">
      <svg class="svg_icon svg_icon_wechat" :data-active="value.find(item => item === 'wechat')" @click="select('wechat')" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="#FFF"><path d="M20.674 12.458c-2.228.116-4.165.792-5.738 2.318-1.59 1.542-2.315 3.43-2.116 5.772-.87-.108-1.664-.227-2.462-.294-.276-.023-.602.01-.836.14-.774.438-1.517.932-2.397 1.482.16-.73.266-1.37.45-1.985.137-.45.074-.7-.342-.994-2.673-1.89-3.803-4.714-2.958-7.624.78-2.69 2.697-4.323 5.302-5.173 3.555-1.16 7.55.022 9.712 2.845a6.632 6.632 0 0 1 1.38 3.516zm-10.253-.906c.025-.532-.44-1.01-.984-1.027a.997.997 0 0 0-1.038.964.984.984 0 0 0 .977 1.02 1.017 1.017 0 0 0 1.05-.96zm5.35-1.028c-.55.01-1.01.478-1 1.012.01.554.466.987 1.03.98a.982.982 0 0 0 .99-1.01.992.992 0 0 0-1.02-.982z"></path><path d="M25.68 26.347c-.705-.314-1.352-.785-2.042-.857-.686-.072-1.408.324-2.126.398-2.187.224-4.147-.386-5.762-1.88-3.073-2.842-2.634-7.2.92-9.53 3.16-2.07 7.795-1.38 10.022 1.493 1.944 2.51 1.716 5.837-.658 7.94-.687.61-.934 1.11-.493 1.917.086.148.095.336.14.523zm-8.03-7.775c.448 0 .818-.35.835-.795a.835.835 0 0 0-.83-.865.845.845 0 0 0-.84.86c.016.442.388.8.834.8zm5.176-1.658a.83.83 0 0 0-.824.794c-.02.47.347.858.813.86.45 0 .807-.34.823-.79a.825.825 0 0 0-.812-.864z"></path></g></svg>
      <svg class="svg_icon svg_icon_facebook" :data-active="value.find(item => item === 'facebook')" @click="select('facebook')" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="#FFF" d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z"></path></svg>
      <svg class="svg_icon svg_icon_linkedin" :data-active="value.find(item => item === 'linkedin')" @click="select('linkedin')" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M6.227 12.61h4.19v13.48h-4.19V12.61zm2.095-6.7a2.43 2.43 0 0 1 0 4.86c-1.344 0-2.428-1.09-2.428-2.43s1.084-2.43 2.428-2.43m4.72 6.7h4.02v1.84h.058c.56-1.058 1.927-2.176 3.965-2.176 4.238 0 5.02 2.792 5.02 6.42v7.395h-4.183v-6.56c0-1.564-.03-3.574-2.178-3.574-2.18 0-2.514 1.7-2.514 3.46v6.668h-4.187V12.61z" fill="#FFF"></path></svg>
    </template>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name: 'my_share',
    components: {}, // 注册组件
    directives: {},
    props: {
      value: {
        type: Array,
        default: () => []
      },
      leftWidth: { // 标题宽度
        type: String,
        default: '75'
      },
    },
    data() {
      return {
        formInline: {
          channelName: '',
          page: {
            total: 0,
            pageSize: 10,
            currentPage: 1
          }
        },
        filter: {
          listingNameOptions: []
        },
        tableTile: [],
        loading: true,
        tableData: []
      }
    },
    computed: {}, // 计算属性
    watch: {},
    beforeCreate() {
    },
    created() {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    beforeDestroy() {
    },
    methods: {
      select(val) {
        const _value = this.value.map(item => item)
        if (_value.find(item => item === val)) {
          this.$emit('input', _value.filter(item => item !== val))
        } else {
          _value.push(val)
          this.$emit('input', _value)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .g-share-box {
    display: flex;
    .u-icon {
      font-size: 20px;
      margin-right: 5px;
      color: #ccc;
      cursor: pointer;
    }
    .icon-weixin[data-active] {
      color: #46d42f;
    }
    .icon-weibo-copy1[data-active] {
      color: #f44336;
    }
    .icon-qq[data-active] {
      color: #2992fc;
    }
    .svg_icon {
      width: 20px;
      height: 20px;
      margin-right: 5px;
      margin-bottom: 10px;
      display: inline-block;
      background-color: #ccc;
      border-radius: 50%;
    }
    .svg_icon_twitter {
      opacity: 0.2;
    }
    .svg_icon_twitter[data-active] {
      background-color: rgb(85, 172, 238);
      opacity: 1;
    }
    .svg_icon_wechat[data-active] {
      background-color: rgb(123, 179, 46);
    }
    .svg_icon_facebook[data-active] {
      background-color: rgb(24, 119, 242);
    }
    .svg_icon_linkedin[data-active] {
      background-color: rgb(0, 123, 181);
    }
    .svg_icon_instagram[data-active] {
      background-color: rgb(202, 224, 255);
    }
    .svg_icon_youtobe[data-active] {
      background-color: rgb(202, 224, 255);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my_share/index.vue